module.exports = __webpack_public_path__ + "img/yanhua.45d389d9.png";